<script lang="ts">
import { Vue, Options } from 'vue-class-component';

type FacingCameraType = 'user' | 'environment';

@Options({
    emits: ['cameraMounted', 'cameraUnmounted', 'onClose', 'onPicture']
})
export default class Camara extends Vue
{
    public className: string = '';
    public video: HTMLVideoElement = null;
    public canvas: HTMLCanvasElement = null;
    public picture: string = null;
    public mediaStream: MediaStream = null;
    public facingMoge: FacingCameraType = 'environment';

    public get mediaConstraints(): MediaStreamConstraints
    {
        return {
            video: {
                facingMode: this.facingMoge,
                aspectRatio: 4/3,
                width: 1440,
                height: 1080
            },
        };
    }

    public async initCamera(): Promise<void>
    {
        this.video = this.$refs.video as HTMLVideoElement;
        this.canvas = this.$refs.canvas as HTMLCanvasElement;

        try
        {
            this.mediaStream = await navigator.mediaDevices.getUserMedia(this.mediaConstraints);
            this.video.srcObject = this.mediaStream;

            const [ track ] = this.mediaStream.getVideoTracks();

            const facingMode = track.getCapabilities()?.facingMode?.[0] as FacingCameraType;

            if (facingMode)
                this.facingMoge = facingMode;

            this.$emit('cameraMounted');

        }
        catch (ex)
        {
            console.error(ex);
            this.$alert.error(this.$t('[[[Wystąpił problem z dostępem do kamery]]]'));
        }
    }

    public stopCamera(): void
    {
        if (this.mediaStream)
        {
            this.mediaStream.getTracks().forEach(track => track.stop());
            this.video.srcObject = null;
        }

        this.$emit('cameraUnmounted');
    }

    public mounted(): void
    {
        this.initCamera();

        setTimeout(() =>
        {
            this.className = 'translate';
        }, 100);
    }

    public capture(): void
    {
        const context = this.canvas.getContext('2d');

        this.canvas.width = this.video.videoWidth;
        this.canvas.height = this.video.videoHeight;

        context.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);
        this.picture = this.canvas.toDataURL("image/jpeg", 1.0);
    }

    public recapture(): void
    {
        this.picture = null;
    }

    public changeCamera(): void
    {
        if (this.facingMoge === 'user')
            this.facingMoge = 'environment';
        else
            this.facingMoge = 'user';

        this.stopCamera();
        this.initCamera();
    }

    public handleClose(): void
    {
        this.className = '';
        setTimeout(() =>
        {
            this.stopCamera();
            this.$emit('onClose');
        }, 300);
    }

    public handlePicture(): void
    {
        this.$emit('onPicture', this.picture);
        this.handleClose();
    }
}

</script>
<template>
    <teleport to="body">
        <div class="camera-wrapper">
            <div :class="['camera-view', className]">
                <ideo-button v-if="picture" class="close-btn" @click="handlePicture">gotowe</ideo-button>
                <ideo-button v-else class="close-btn" @click="handleClose">zamknij</ideo-button>
                <div class="content">
                    <video autoplay ref="video"></video>
                    <canvas ref="canvas" v-show="picture"></canvas>
                </div>
            </div>
            <div v-show="className" class="controls">
                <action-button @click="changeCamera" class="button" variant="primary" icon="fa fa-solid fa-camera-rotate" :text="$t('[[[obrót]]]')" />
                <button @click="capture" class="shoot-button"></button>
                <action-button @click="recapture" class="button" variant="primary" icon="fa fa-solid fa-image-slash" :text="$t('[[[reset]]]')" />
            </div>
        </div>
    </teleport>
</template>
<style lang="scss" scoped>
.camera-wrapper{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 11000;
    .camera-view{
        width: 100vw;
        height: 100vh;
        transition: transform .2s ease-in-out;
        transform: translateY(100%);
        background: $black;
        &.translate{
            transform: translateY(0);
        }

        .content{

            video, canvas{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 100%;
                height: auto;
                max-width: 100vw;
                max-height: 100vh;
                object-fit: contain;
            }
        }

        .close-btn{
            position: absolute;
            top: 20px;
            right: 20px;
            z-index: 1;
        }
    }
    .controls{
        width: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: space-evenly;
        position: fixed;
        bottom: 20px;
        left: 0;
        z-index: 1;
        .shoot-button{
            width: 70px;
            height: 70px;
            background: $white;
            border: 5px solid var(--primary);
            border-radius: 50%;
            transition: transform .005s ease-in-out;
            &:active{
                transform: scale(0.9);
            }
        }
    }
}
</style>